export default () => ({
    swiper: null,
    initialized: false,
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.categoriesCarousel, {
            slidesPerView: 4,
            spaceBetween: 8,
            pagination: false,
            navigation: true,
            loop: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                },
                568: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 3.5,
                },
                1280: {
                    slidesPerView: 4.5,
                },
                1536: {
                    spaceBetween: 12,
                },
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
            on: {
                init: () => {
                    // Defer toggle to next frame to allow Alpine bindings to react
                    requestAnimationFrame(() => {
                        this.initialized = true;
                    });
                },
            },
        });
    },
    checkBreakpoint() {
        const mediaQuery = '(min-width: 768px)';
        const mediaQueryList = window.matchMedia(mediaQuery);

        if (mediaQueryList.matches) {
            this.enable();
        } else {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
        }

        mediaQueryList.addEventListener('change', event => {
            if (event.matches) {
                this.enable();
            } else {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                }
            }
        });
    },
});